import * as React from "react";
import { RemoveLinkLabelModel } from "./RemoveLinkLabelModel";
import styled from "@emotion/styled";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

export interface RemoveLinkLabelWidgetProps {
  model: RemoveLinkLabelModel;
}

export const Container = styled.div`
  height: 30px;
  width: 80px;
  pointer-events: all;
`;

export class RemoveLinkLabelWidget extends React.Component<RemoveLinkLabelWidgetProps> {
  onClick = () => {
    this.props.model.removeLink();
  };

  render() {
    return (
      <Container>
        <Button onClick={this.onClick} type="dashed" danger shape="circle">
          <DeleteOutlined />
        </Button>
      </Container>
    );
  }
}
